<template>
  <div class="bg-grey-light c-adv" v-if="currentItem">
    <little-header></little-header>
    <!--<div class="bg-white top-search-nav" v-if="type==='chome'||type==='cadv'">-->
    <!--<van-nav-bar class="w-100"-->
    <!--left-arrow-->
    <!--@click-left="onClickLeft"-->
    <!--@click-right="onClickRight">-->
    <!--<template #title>-->
    <!--<van-search-->
    <!--v-model="value"-->
    <!--shape="round"-->
    <!--background="#fff"-->
    <!--placeholder="搜索感兴趣的课程"-->
    <!--@search="onSearch"-->
    <!--/>-->
    <!--</template>-->
    <!--<template #right>-->
    <!--<svg t="1593865775118" class="icon " viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"-->
    <!--p-id="7045" width="18" height="18">-->
    <!--<path-->
    <!--d="M861.499077 681.984c-67.032615 0-121.856 37.651692-147.298462 96.177231L390.065231 633.462154c18.904615-30.72 29.302154-68.450462 29.302154-109.095385 0-16.856615-1.890462-33.713231-5.671385-49.545846l206.848-168.566154c27.411692 21.897846 62.385231 34.737231 101.060923 34.737231 93.577846 0 163.446154-73.334154 163.446154-170.456615C885.129846 73.255385 815.261538 0 721.683692 0 628.184615 0 559.261538 73.334154 559.261538 170.535385c0 24.733538 4.726154 47.576615 12.288 67.347692L380.691692 391.561846c-37.809231-59.470769-100.115692-101.139692-170.92923-101.139692C93.420308 290.422154 0 388.568615 0 510.503385s93.499077 220.081231 209.683692 220.08123c43.480615 0 84.125538-11.894154 117.129846-33.71323l372.263385 166.518153c4.726154 92.16 72.704 160.610462 162.422154 160.610462C955.076923 1024 1024 950.665846 1024 853.464615c0-97.122462-69.868308-171.480615-162.500923-171.480615zM721.683692 71.364923c46.316308 0 93.577846 36.706462 93.577846 98.146462s-34.973538 98.146462-93.577846 98.146461c-58.525538 0-93.499077-48.600615-93.499077-98.146461 0-49.624615 47.261538-98.146462 93.499077-98.146462z m-512 585.885539c-69.868308 0-128.393846-61.44-128.393846-134.852924 0-73.334154 58.525538-134.774154 128.393846-134.774153 69.947077 0 128.472615 61.44 128.472616 134.774153-0.945231 73.334154-58.525538 134.852923-128.393846 134.852924z m651.815385 293.415384c-58.525538 0-93.499077-36.706462-93.499077-98.146461s46.316308-98.146462 93.499077-98.146462c47.261538 0 93.577846 36.706462 93.577846 98.146462-0.945231 61.44-35.918769 98.146462-93.577846 98.146461z"-->
    <!--fill="#888888" p-id="7046"></path>-->
    <!--</svg>-->
    <!--</template>-->
    <!--</van-nav-bar>-->

    <!--</div>-->
    <div class="super-course d-flex flex-column-reverse"
         :style="'background-image: url('+coverUrl+')'">

      <div class="video-button" v-if="currentItem.helpVideo" @click="openVideo">
        <svg t="1592286045552" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="21623" width="32" height="32">
          <path
            d="M711.652513 498.556564l-291.357735-247.878965c-4.19795-3.698194-9.295461-5.397365-14.293021-5.397365-10.794729 0-20.989751 7.49634-20.989751 18.990727v495.857882c0 11.394436 10.195022 18.990727 20.989751 18.990728 4.99756 0 10.095071-1.599219 14.293021-5.397365l291.357735-247.878965c8.495852-7.49634 8.495852-19.790337 0-27.286677z m110.945828 324.541533c-40.380283 40.380283-87.457296 72.064812-139.831723 94.253977-54.073597 22.988775-111.645486 34.583114-171.016496 34.583114s-116.942899-11.594339-171.116447-34.583114c-52.374427-22.089214-99.351489-53.873694-139.831723-94.253977-40.380283-40.380283-72.064812-87.457296-94.253977-139.831723-22.788873-54.073597-34.483163-111.645486-34.483163-171.016496 0-59.37101 11.594339-116.942899 34.583114-171.116447 22.089214-52.374427 53.873694-99.351489 94.253977-139.831723 40.380283-40.380283 87.457296-72.064812 139.831723-94.253977C394.807223 84.258858 452.379112 72.664519 511.750122 72.664519s116.942899 11.594339 171.116447 34.583114c52.374427 22.089214 99.351489 53.873694 139.831723 94.253978 40.380283 40.380283 72.064812 87.457296 94.253977 139.831722 22.788873 54.073597 34.483163 111.645486 34.483163 171.016496 0 59.37101-11.594339 116.942899-34.583114 171.116447-22.189165 52.274475-53.773743 99.251537-94.253977 139.631821zM511.750122 0.499756C229.088141 0.499756 0 229.687848 0 512.249878s229.088141 511.750122 511.750122 511.750122 511.750122-229.088141 511.750122-511.750122S794.412103 0.499756 511.750122 0.499756z"
            p-id="21624" fill="#e3e3e3"></path>
        </svg>
      </div>
      <div class="z-999">
        <van-sticky v-if="currentItem.helpVideoResource && currentItem.helpVideoResource.url">
          <div class="openVideo">
            <div class="video-block">
              <iframe class="w-100 h-100" :src="'/static/videott/index1.html?vid='+currentItem.helpVideoResource.url"/>
            </div>
          </div>
        </van-sticky>
      </div>


      <div class="dotwrapper prh-dotwrapper">
        <div class="qian1 position-absolute" v-if="currentItem.tag&&currentItem.tag[1]">
          <div class="dian">
          </div>
          <span class="txt">{{currentItem.tag[1]}}</span>
        </div>
        <div class="qian2 position-absolute" v-if="currentItem.tag&&currentItem.tag[0]">
          <div class="dian">
          </div>
          <span class="txt">{{currentItem.tag[0]}}</span>
        </div>
        <div class="qian3 position-absolute" v-if="currentItem.tag&&currentItem.tag[3]">
          <div class="dian">
          </div>
          <span class="txt">{{currentItem.tag[3]}}</span>
        </div>
      </div>
      <div class=" text-white px-3 py-2 pro-descript"
           :class="{'py-0': type==='cadv','d-flex':type==='chome'}">
        <p class="mb-1 text-white title text-truncate overflow-hidden font-13"
           :class="{'w-80':type==='chome'}">
          {{(type==='shome'||type==='acthome')?currentItem.name:currentItem.title}}
        </p>
        {{currentItem.startDate}}
        <p v-if="type==='shome'||type==='acthome'" class="font-10 mb-0 text-white data d-flex justify-content-between">
          开放时间：{{currentItem.learningStartTime|dateFormat('YYYY-MM-DD HH:mm')}} 至 {{currentItem.learningEndTime|dateFormat('YYYY-MM-DD HH:mm')}}

          <a class="text-white cursor-pointer font-10 line-18" href="javascript:;" @click="toDetail(currentItem)">
            查看详情>
          </a>
        </p>
        <span v-else-if="type==='chome'" class="ml-auto text-white font-10 line-18 cursor-pointer" @click="toDetail(currentItem)">查看详情 ></span>
      </div>
    </div>

    <div class="prh-desc px-3 py-20 bg-white font-12 color-88 mb-2"
         v-if="type==='shome'||type==='acthome' ||(type==='cadv' && isProAdvCourse)">
      <div class="d-flex">
        <div class="mr-2 biao" v-if="type==='shome'&& currentItem.summary"></div>
        <div class="w-100">
          <!-- 普通预售课程-->
<!--          <div v-if="type==='cadv' && !isProAdvCourse && currentItem.creatorUser"-->
<!--               class="px-2 d-flex justify-content-between align-items-center font-15 line-15 color-0d">-->
<!--            <div class="cUser">-->
<!--              <img class="img mr-12" :src="currentItem.creatorUser.avatarUrl|getAvator">-->
<!--              {{currentItem.creatorUser.nickname}}-->
<!--            </div>-->
<!--&lt;!&ndash;            <router-link to="/app/down" class="font-13 line-15 color-base py-1 gz-btn font-weight-bold">关注</router-link>&ndash;&gt;-->
<!--          </div>-->
          <!-- 项目预售课程-->
          <div v-if="type==='cadv' && isProAdvCourse"
               class="px-2 d-flex align-items-center font-15 line-15 color-0d">
            <img class="cpro-img1 mr-12" style="flex:none;" src="/static/img/pro/position.png">
            <div class="text-truncate">{{projectName}}</div>
            <img class="cpro-img2 ml-auto" style="flex:none;" src="/static/img/pro/course-project-title.png">
          </div>
          <div v-if="type==='shome'&& currentItem.summary"
               class="desc line-18 text-justify van-multi-ellipsis--l2">
            <span>【简述】</span>
            {{currentItem.summary}}
          </div>
          <van-popup
            v-model="showPop"
            closeable
            round
            position="bottom"
            :style="{ height: '80%' }">
            <p class="position-absolute big-Title font-weight-bold">学习服务</p>
            <div class="adv-pop-content mt-4 pt-32">
              <van-skeleton title avatar :row="3" :loading="loadingPop">
                <div class="mb-20 course-adv-service d-flex">

                  <div class="fuwu-icon">
                    <img src="/static/img/pro/xuexifuwu1.png" alt="">
                  </div>
                  <div>
                    <p class="title mb-12">无线回看</p>
                    <p class="mb-0 desc">订阅课程后永久回看，VIP年卡等权益有限期内无线回看</p>
                  </div>
                </div>
              </van-skeleton>
              <van-skeleton title avatar :row="3" :loading="loadingPop">
                <div class="mb-20 course-adv-service d-flex">
                  <div class="fuwu-icon">
                    <img src="/static/img/pro/xuexifuwu2.png" alt="">
                  </div>
                  <div>
                    <p class="title mb-12">课后作业</p>
                    <p class="mb-0 desc">订阅课程后永久回看，VIP年卡等权益有限期内无线回看</p>
                  </div>
                </div>
              </van-skeleton>
              <van-skeleton title avatar :row="3" :loading="loadingPop">
                <div class="mb-20 course-adv-service d-flex">
                  <div class="fuwu-icon">
                    <img src="/static/img/pro/xuexifuwu3.png" alt="">
                  </div>
                  <div>
                    <p class="title mb-12">讲师互动</p>
                    <p class="mb-0 desc">订阅课程后永久回看，VIP年卡等权益有限期内无线回看</p>
                  </div>
                </div>
              </van-skeleton>
              <van-skeleton title avatar :row="3" :loading="loadingPop">
                <div class="mb-20 course-adv-service d-flex">
                  <div class="fuwu-icon">
                    <img src="/static/img/pro/xuexifuwu4.png" alt="">
                  </div>
                  <div>
                    <p class="title mb-12">实战驱动</p>
                    <p class="mb-0 desc">订阅课程后永久回看，VIP年卡等权益有限期内无线回看</p>
                  </div>
                </div>
              </van-skeleton>
              <van-skeleton title avatar :row="3" :loading="loadingPop">
                <div class="mb-20 course-adv-service d-flex">
                  <div class="fuwu-icon">
                    <img src="/static/img/pro/xuexifuwu5.png" alt="">
                  </div>
                  <div>
                    <p class="title mb-12">总结复习</p>
                    <p class="mb-0 desc">订阅课程后永久回看，VIP年卡等权益有限期内无线回看</p>
                  </div>
                </div>
              </van-skeleton>
            </div>

          </van-popup>
        </div>
      </div>
    </div>
    <div  class="prh-jindu mb-2 bg-white px-3 py-4 mt-2" v-if="type==='shome'">
      <div class="bili d-flex font-12 color-33 d-flex">
        <p class="mb-0">课程数：<span class="color-base">{{finishCourseCount}}</span>/共{{sumCourseCount}}节课</p>
        <p class="ml-2 mb-0">学时：<span class="color-base">{{finishCount}}</span>/共{{sumCount}}学时
        </p>
      </div>
<!--      <div class="title d-flex justify-content-between align-items-center mt-3"-->
<!--           v-if="lastLearnedSession.course && lastLearnedSession.course.title ">-->
<!--        <p class="mb-0 w-75 text-truncate peo-title font-14 color-0d">-->
<!--          {{lastLearnedSession.course.title}}</p>-->

<!--        <router-link v-if="canClickLearn" class="primary-bton" :to="{path: '/course/'+ lastLearnedSession.courseId}">-->
<!--          {{isFirst?'开始学习':'继续学习'}}-->
<!--        </router-link>-->
<!--        <div @click="$toast('该课程暂未开放学习！')" class="primary-bton cursor-pointer" v-else >-->
<!--          {{isFirst?'开始学习':'继续学习'}}-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div v-if=" type==='chome'"
         class="prh-jindu mb-2 bg-white pl-28 pr-3 py-4">
      <div class="tiao font-12 color-88 d-flex align-items-center line-15">
        完成进度
        <div class="progress2 w-25 mx-2">
<!--          <van-progress v-if="type==='shome'" class="progress2-bar"-->
<!--                        :percentage="shomeProgress" stroke-width="12"/>-->

          <van-progress class="progress2-bar"
                        :percentage="currentItem.progress?currentItem.progress:0"
                        :stroke-width="progressHeight"/>
        </div>
        <div class="bili font-12 color-33 d-flex">
          {{currentItem.progress|calcMoney}}%(
          <span class="fenzi">{{currentItem.userCourse?currentItem.userCourse.progress:0}}</span>
          /{{currentItem.statInfo?currentItem.statInfo.mustLearnSessionCount:0}}小节)
        </div>
      </div>
<!--      <div class="title d-flex justify-content-between align-items-center mt-3"-->
<!--           v-if="lastLearnedSession.title">-->
<!--        <p class="mb-0 w-75 text-truncate peo-title font-14 color-0d">-->
<!--          {{lastLearnedSession.title}}</p>-->
<!--        <router-link class="primary-bton"-->
<!--                     :to="{path: '/course/'+lastLearnedSession.sessionType+'/'+lastLearnedSession.id}">-->
<!--          {{alreadyLearn?'继续学习':'开始学习'}}-->
<!--        </router-link>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
  import LittleHeader from "@/components/littleHeader";
  import Vue from 'vue';
  import {Icon, NavBar, Overlay, Popup, Progress, Search, Skeleton, Sticky, Button} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Sticky);
  Vue.use(Overlay);
  Vue.use(NavBar);
  Vue.use(Search);
  Vue.use(Skeleton);
  Vue.use(Popup);
  Vue.use(Progress);
  Vue.use(Icon);
  Vue.use(Button);


  export default {
    name: "courseTop",
    data() {
      return {
        value: '',
        showPop: false,
        loadingPop: true,
        typeFromPage: '',
        currentCourse: {},
        coverUrl: '',
        shomeProgress: 0,
        finishCount: 0,
        sumCount: 0,
        finishCourseCount: 0,
        sumCourseCount: 0,
        progressHeight: '.7rem',
        learnCourseTitle: '',
        isFirst: false,
        isProAdvCourse: false,
        proId: '',
        learnCourseId: '',
      }
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl
      }),
    },
    components: {
      LittleHeader
    },
    props: [
      'type',
      'currentItem',
      'shomeRate',
      'canClickLearn', //开始学习按钮是否可点击学习
      'projectId', ///课程详情需要判断是否是项目课程？
      'projectName', ///课程详情需要判断是否是项目课程？
      'lastLearnedSession', //课程主页 传入最后学习的小节----项目主页 传入最后学习课程
      'alreadyLearn', //课程主页 传入是否有学习过的小节，没有 开始，有 继续学习
    ],
    created() {
      if (this.currentItem.coverUrl) {
        this.coverUrl = this.uploadresUrl + this.currentItem.coverUrl
      } else if (this.type === 'shome' && this.currentItem.cover) {
        this.coverUrl = this.uploadresUrl + this.currentItem.cover
      }
    },
    watch: {
      projectId(newVal, oldVal) {
        if (newVal) {
          this.proId = newVal;
          this.isProAdvCourse = true;
        }
      },
      currentItem(newVal, oldVal) {
        if (newVal.coverUrl) {
          this.coverUrl = this.uploadresUrl + newVal.coverUrl
        } else if ((this.type === 'shome' || this.type === 'acthome') && newVal.cover) {
          this.coverUrl = this.uploadresUrl + newVal.cover;
        }
        if (this.type === 'shome') {
          if(newVal.userProject) {
            if (newVal.userProject.lastLearnCourseTitle) {
              this.isFirst = false;
            } else {
              this.isFirst = true;
            }
            this.finishCount = newVal.userProject.progressCredit?newVal.userProject.progressCredit:0;
            this.sumCount = newVal.userProject.courseCredit?newVal.userProject.courseCredit:0;
            this.finishCourseCount = newVal.userProject.progress?newVal.userProject.progress:0;
            this.sumCourseCount = newVal.userProject.courseCount?newVal.userProject.courseCount:0;
          }
        }

      }
    },
    methods: {
      showPopup() {
        this.showPop = true;
        this.loadingPop = false;
      },

      toDetail(item) {
        if (item && this.type === 'chome') {
          // if (sessionStorage.getItem('currentCourse')) {
          //   sessionStorage.removeItem('currentCourse')
          // }
          // sessionStorage.setItem('currentCourse', JSON.stringify(item));
          this.$router.push({name: 'CourseDetail', params: {id: item.id}, query: {proId: this.proId}});

        } else if (item && (this.type === 'shome' || this.type === 'acthome')) {
          this.$router.push('/project-detail/' + item.id);
        }

      },
      openVideo() {
        $('.openVideo').show();
        $('.openVideo').addClass('videoFixed');
      }
    },
  }
</script>

<style>
  .videoFixed {
    position: fixed !important;
  }

  .course-adv-service .van-icon {
    font-size: 1.5rem;
    flex: 0 0 1.5rem;
    margin-right: 1rem;
  }

  .course-adv-service .title {
    font-size: .9375rem;
    font-weight: bold;
    margin-bottom: 1rem;
    color: #333333;
  }

  .course-adv-service .desc {
    font-size: .75rem;
    color: #888888;
  }

  .c-adv .van-popup--bottom {
    padding: 1.75rem 1rem;
    right: 0;
    max-width: 640px;
    margin: 0 auto;
  }

  .c-adv .big-Title {
    font-size: 1.125rem;
    top: 0;
    left: 0;
    margin: 1.5rem 0 0 1rem;
    color: #0d0d0d;
  }

  .c-adv .van-popup__close-icon--top-right {
    top: 1.5rem;
    right: 1rem;
    font-size: 1.1875rem;
  }

 .progress2 .van-progress__pivot {
    display: none
  }

  .progress2 .progress2-bar {
    background-color: #e9ecef !important;
  }

  .van-progress__portion {
    background: #FFA039 !important;
  }

  .top-search-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 3.75rem;
  }

  .top-search-nav .van-search {
    padding: 0;
  }

  .top-search-nav .van-cell .van-field__left-icon {
    display: flex;
    align-items: center;
  }

  .top-search-nav .van-search__content {
    background-color: #fdfdfd;
    border: 1px solid #d7d7d7;
    padding-left: 1.25rem;
  }

  .top-search-nav .van-nav-bar .van-icon {
    color: #888888 !important;
    font-size: 1.125rem;
  }

  .top-search-nav .van-nav-bar .icon {
    color: #888888 !important;
    width: 1.125rem;
    height: 1.125rem;
  }

  .top-search-nav .van-hairline--bottom::after {
    border-bottom-width: 0;
  }


  .top-search-nav .van-nav-bar__title {
    margin-left: 3rem;
    width: 69%;
    max-width: 80%;
  }

  .top-search-nav .van-search {
    padding: 0;
  }

  .top-search-nav .van-search__content {
    background-color: #fdfdfd;
    border: 1px solid #d7d7d7;
    padding-left: 1.25rem;
  }

  .top-search-nav .van-nav-bar .van-icon {
    color: #888888 !important;
  }

  .top-search-nav .van-field__control {
    color: #888888 !important;
    font-size: .9375rem;
  }

  .fuwu-icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: .75rem;
  }

  .fuwu-icon img {
    width: 100%;
  }

  .van-sticky .openVideo {
    position: static !important;
    display: none;
    z-index: 300;
    top: 0;
    left: 0;
    right: 0;
    max-width: 640px;
    margin: 0 auto 0;
    height: 13rem;
    background-color: rgba(0, 0, 0, .7);
  }

  .openVideo .video-block {

    width: 100%;
    height: 100%;
  }

  .gz-btn {
    border: 1px solid #2474FF;
    padding: .25rem 1.125rem;
    border-radius: .5rem;
  }

  .cUser .img {
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
  }

  .cpro-img1 {
    width: .875rem;
    height: .875rem;
  }

  .cpro-img2 {
    /*width: 4.25rem;*/
    height: 1rem;
  }

  .z-999 {
    z-index: 999;
  }
</style>
